import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { pathToRegexp } from "path-to-regexp";
import { removeLocaleFromUrl } from "../../ui/routing/util";
export var RouteMatcher = /*#__PURE__*/ function() {
    "use strict";
    function RouteMatcher(routes) {
        _class_call_check(this, RouteMatcher);
        this.routes = Object.freeze(routes.map(function(r) {
            if (Array.isArray(r)) {
                return [
                    r[0],
                    pathToRegexp(r[0]),
                    r[1]
                ];
            }
            return [
                r,
                pathToRegexp(r)
            ];
        }));
    }
    var _proto = RouteMatcher.prototype;
    // eslint-disable-next-line @faire/prefer-arrow-methods
    _proto.match = function match(pathOrLocation) {
        var pathname = typeof pathOrLocation === "string" ? pathOrLocation : pathOrLocation.pathname;
        if (!pathname) {
            return undefined;
        }
        var normalizedPath = removeLocaleFromUrl(pathname);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.routes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 3), route = _step_value[0], regexp = _step_value[1], value = _step_value[2];
                if (regexp.test(normalizedPath)) {
                    return {
                        route: route,
                        match: regexp.exec(normalizedPath),
                        value: value
                    };
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    };
    return RouteMatcher;
}();
RouteMatcher.of = function() {
    for(var _len = arguments.length, routes = new Array(_len), _key = 0; _key < _len; _key++){
        routes[_key] = arguments[_key];
    }
    return new RouteMatcher(routes);
};
export function pathMatchesRoute(pathOrLocation, route) {
    var pathname = typeof pathOrLocation === "string" ? pathOrLocation : pathOrLocation.pathname;
    if (!pathname) {
        return false;
    }
    return pathToRegexp(route).test(removeLocaleFromUrl(pathname));
}
